const actions = {
  SET_STATE: 'utility/SET_STATE',
  FETCH_ALL_CURRENCY: 'utility/FETCH_ALL_CURRENCY',
  FETCH_ALL_COUNTRY: 'utility/FETCH_ALL_COUNTRY',
}

export default actions
